export const label = 'Номер пакування';
export const maxLength = 20;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
